import { createUseStyles } from 'react-jss';

import { Theme } from '@app/theme';
import { Session } from '@app/api';
import { useIsAdmin } from '@app/api';
import { NotFound } from '@app/core';
import { MonitoringAdminSidePanel } from './components/MonitoringAdminSidePanel';
import { AdminMonitoringContent } from './components/AdminMonitoringContent';

const useStyles = createUseStyles((theme: Theme) => ({
  wrapper: {
    flex: 1,
    position: 'relative',
    width: '100vw',
  },
  container: {
    ...theme.absoluteFill,
    overflow: 'auto',
    backgroundColor: theme.colors.grayBackground,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'row',
  },
  paddedContainer: {
    width: '100%',
    minWidth: theme.maxContentWidth.reduced,
    height: 'fit-content',

    padding: [
      [
        theme.marginBase * 7,
        theme.marginBase * 10,
        theme.marginBase * 4,
        theme.marginBase * 10,
      ],
    ],
    [theme.media.tablet]: {
      paddingLeft: theme.marginBase * 3,
      paddingRight: theme.marginBase * 3,
    },
    [theme.media.mobile]: {
      paddingLeft: theme.marginBase,
      paddingRight: theme.marginBase,
    },
  },
  overviewContainer: {
    background: theme.colors.white,
    width: theme.maxContentWidth.reduced,
    top: 0,
    position: 'sticky',
    overflow: 'auto',
    padding: [
      [
        theme.marginBase * 4,
        theme.marginBase * 3,
        theme.marginBase * 4,
        theme.marginBase * 5,
      ],
    ],
    height: '100%',
  },
}));

interface Props {
  session: Session;
}

export const AdminMonitoring = ({ session }: Props) => {
  const classes = useStyles();
  const isAdmin = useIsAdmin();

  if (!isAdmin) {
    return <NotFound />;
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <div className={classes.overviewContainer}>
          <MonitoringAdminSidePanel session={session} />
        </div>
        <div className={classes.paddedContainer}>
          <AdminMonitoringContent session={session} />
        </div>
      </div>
    </div>
  );
};
